<template>
    <section class="newsletter">
        <div class="col" v-html="content" @click="open">

        </div>
    </section>
</template>

<script>
import { EventBus } from '@/events/bus.js';

export default {
    name: 'newsletter',

    props: {
        content: {
            type: String,
            default: '',
        },
    },

    methods: {
        open() {
            EventBus.$emit('newsletter.open');
        },
    },
}
</script>
<style lang="scss">
    .newsletter {
        .col {
            background: var(--orange);
            font-size: var(--title-size);
            line-height: 1.05;
            padding: 4rem 0;
            color: var(--font-color);
            cursor: pointer;
        }
    }
</style>